import { render, staticRenderFns } from "./WidgetOverview.vue?vue&type=template&id=0a26d382&scoped=true"
import script from "./WidgetOverview.vue?vue&type=script&lang=js"
export * from "./WidgetOverview.vue?vue&type=script&lang=js"
import style0 from "./WidgetOverview.vue?vue&type=style&index=0&id=0a26d382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26d382",
  null
  
)

export default component.exports